import Leaflet from "leaflet";
export * from "leaflet";

if (!window.POLKURIER) {
    window.POLKURIER = {};
}
window.POLKURIER.Leaflet = Leaflet;
